<script>
export default {
  props: {
    gif: {
      type: String,
      required: true
    }
  }
};
</script>

<template>
  <div :class="`loader ${gif}`"></div>
</template>

<style scoped>
@keyframes rotateSpinner-loader {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.loader {
  background: #cc006e;
  border-radius: 50%;
  height: 190px;
  overflow: hidden;
  position: relative;
  width: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader::before {
  animation: rotateSpinner-loader 4s infinite linear;
  background: rgba(255, 255, 255, 0.4);
  content: "";
  height: 95px;
  left: 0;
  position: absolute;
  top: 0;
  width: 95px;
  -webkit-transform-origin: 95px 95px;
  transform-origin: 95px 95px;
}
.loader::after {
  border-radius: 50%;
  box-shadow: inset 0 0 0 5px #fff;
  content: "";
  height: 170px;
  left: 10px;
  position: absolute;
  top: 10px;
  width: 170px;
}

.loader.squeegee::after {
  background: url("/static/squeegee.gif") no-repeat center;
}
.loader.broom::after {
  background: url("/static/broom.gif") no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Preloader/Loader.vue